'use client'

import { FC } from 'react'

import { ITenantSelectionFormProps } from './types'

const TenantSelectionForm: FC<ITenantSelectionFormProps> = ({
  tenants,
  onSelectTenant,
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <p className="prose-body">Carregando agências...</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col w-full bg-white gap-4">
      <div className="flex flex-col gap-2">
        <p className="prose-body">Selecione a agência que deseja acessar:</p>
        <div className="grid grid-cols-1 gap-3 max-h-[400px] overflow-y-auto">
          {tenants.map((tenant) => (
            <div
              key={tenant.tenantId}
              className="bg-white rounded-lg shadow-sm border border-grayscale-200 p-4 hover:shadow-md hover:border-primary-500 transition-all cursor-pointer"
              onClick={() => onSelectTenant(tenant)}
            >
              <div className="flex flex-col gap-2">
                <h3 className="prose-body-large font-semibold text-grayscale-900">
                  {tenant.tenantName}
                </h3>
                {tenant.statusName && (
                  <p className="prose-body-small text-grayscale-600">
                    {tenant.statusName}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TenantSelectionForm
